module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"notice_detail":"View notice details"}}')
  delete Component.options._Ctor
}
